module.exports = __webpack_public_path__ + "img/level-1.9b3ce135.png";